<template>
  <div class="l-flex-column chart-block monitoring-breakdown">
    <div class="breakdown-content container-loading is-loading" v-if="audienceIsLoading">
      <div class="content">
        <div class="stripe medium-stripe title" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
      </div>
      <div class="content">
        <div class="stripe medium-stripe title" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
      </div>
      <div class="content">
        <div class="stripe medium-stripe title" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
        <div class="stripe small-stripe category" />
      </div>
    </div>
    <div v-else-if="optionExists('gender') || optionExists('age') || optionExists('income') || optionExists('education')">
      There is no user reached ...
    </div>
    <div v-else class="breakdown-content">
      <div class="is-card">
        <p>
          Gender
        </p>
        <div v-if="optionExists('gender')" width="100" height="100" style="margin-top: 40px">
          no gender available
        </div>
        <v-chart
          v-else
          class="chart-breakdown"
          :option="getOptions('gender')"
          autoresize
        />
      </div>

      <div class="is-card is-age">
        <p>
          Age
        </p>
        <div v-if="optionExists('age')" width="100" height="100" style="margin-top: 40px">
          no age available
        </div>
        <v-chart
          v-else
          class="chart-breakdown"
          :option="getOptions('age')"
          autoresize
        />
      </div>
      <div class="is-card">
        <p>
          Income
        </p>
        <div v-if="optionExists('income')" width="100" height="100" style="margin-top: 40px">
          no income available
        </div>
        <v-chart
          v-else
          class="chart-breakdown"
          :option="getOptions('income')"
          autoresize
        />
      </div>
      <div class="is-card">
        <p>
          Education
        </p>
        <div v-if="optionExists('education')" width="100" height="100" style="margin-top: 40px">
          no education available
        </div>
        <v-chart
          v-else
          class="chart-breakdown"
          :option="getOptions('education')"
          autoresize
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep, isNil, find } from 'lodash'

export default {
    data() {
        return {
            sortClusterBy: 'cluster_in_segment',
            clusterOrder: 'desc',
            options: {
                tooltip: {
                    trigger: 'item',
                    borderColor: 'white'
                },
                toolbox: {
                    show: true,
                    showTitle: false
                },
                legend: {
                    top: 'center',
                    left: 0,
                    orient: 'vertical',
                    show: true,
                    textStyle: {
                        fontSize: 14,
                        fontFamily: 'weborama',
                        color: '#000000'
                    },
                },
                color: ['#786AF4', '#33A6FF', '#7AABD1', '#4498E2', '#4048EF'],
                series: [
                    {
                        type: 'pie',
                        radius: ['60%', '90%'],
                        left: '55%',
                        top: 0,
                        label: {
                            show: false,
                            fontSize: 18,
                        },
                        labelLine: {
                            show: false
                        },
                        data: [],
                        itemStyle: {
                            borderWidth: '0',
                            borderColor: 'white'
                        }
                    }
                ]
            },
            optionBar: {
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}%',
                    fontFamily: 'weborama',
                    fontSize: 16,
                    fontWeight: '400',
                },
                grid: {
                    top: 20,
                    bottom: 20
                },
                tooltip: {
                    trigger: 'item',
                    borderColor: 'white',
                    top: '0%',
                    show: false
                },
                legend: {show: false},
                xAxis: {
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    show: false
                },
                color: ['#786AF4', '#33A6FF', '#7AABD1', '#4498E2', '#4048EF'],
                series: [{
                    name: 'Sale',
                    type: 'bar',
                    data: [{value: 5}, 20, 36, 10, 10, 20, 4],
                    barWidth: 7,
                    itemStyle: {
                        borderRadius: [5, 5, 5, 5]
                    }
                }]
            },
            tabActive: 'gender',

            ageLegend: {
                'Aged 18 to 24': {
                    color:'#4498E2',
                    name: '18-24'
                },
                'Aged 25 to 34': {
                    color:'#4048EF',
                    name: '25-34'
                },
                'Aged 35 to 49': {
                    color:'#2DC9EB',
                    name: '35-49'
                },
                'Aged 50 to 64': {
                    color:'#809FB8',
                    name: '50-64'
                },
                'Aged 65 and more': {
                    color:'#645AFF',
                    name: '65+'
                }
            }
        }
    },

    computed: {
        ...mapState('ui/monitoring', {
            audienceIsLoading: state => state.isLoading.breakdown,
            audienceSelectedId: state => state.selectedRowId
        }),

        ...mapState('data/audience', {
            audienceList: state => state.list
        }),

        selectedAudience() {
            return find(this.audienceList, audience => audience.id === this.audienceSelectedId)
        },

        // ...mapState('builder', {
        //     breakdown: state => state.formulaBreakdown,
        //     isLoading: state => state.formulaBreakdownLoading,
        // }),

        haveData() {
            return !!this.breakdown
        },

        breakdown() {
            if (
                !isNil(this.selectedAudience) &&
                !isNil(this.selectedAudience.breakdown)
            ) {
                return this.selectedAudience.breakdown
            }
            return {}
        },
    },

    methods: {
        optionExists(category) {
            return !this.breakdown?.[category]
        },

        generateOptions(category) {
            if (!this.breakdown?.age) {
                return
            }
            if(category === 'age') {
                this.optionBar.series[0].data = Object.keys(this.breakdown.age).map((key) => {
                    const fragment = this.breakdown.age[key]
                    return {
                        name: this.ageLegend[key].name,
                        value: Math.round(fragment.volume),
                        tooltip: {
                            trigger: 'item',
                            formatter: '<div class="content-tooltip"><span>{b} : </span><span class="tooltip-value">{c} %</span></div>',
                            borderColor: 'white'
                        },
                        itemStyle: {
                            color: this.ageLegend[key].color
                        }
                    }
                })
                this.optionBar.xAxis.data = Object.keys(this.breakdown.age).map((key) => this.ageLegend[key].name)

                return this.optionBar
            }

            const currentData = this.breakdown[category]

            if (currentData) {
                const _options = cloneDeep(this.options)
                _options.series[0].data = Object.keys(currentData).map((key) => {
                    return {
                        value: Math.round(currentData[key].volume),
                        name: key,
                        tooltip: {
                            trigger: 'item',
                            formatter: this.getChartTooltip(key, category),
                            borderColor: 'white'
                        }
                    }
                })

                if(category === 'gender') {
                    _options.series[0].itemStyle.borderWidth = '0'
                }

                _options.series[0].itemStyle.borderWidth = '2'
                return _options
            }
            return {}
        },

        getChartTooltip(key, tab) {
            if (tab === 'gender') {
                return `<div class="content-tooltip is-gender"><span class="tooltip-gender ${key.toLowerCase()}"></span><span class="tooltip-value">{c} %</span></div>`
            }

            return '<div class="content-tooltip"><span>{b} : </span><span class="tooltip-value">{c} %</span></div>'
        },

        getOptions(category) {
            return this.generateOptions(category)
        }
    }
}
</script>

<style lang="scss">

.monitoring-breakdown {
  .is-card {
    display: block; height: 260px; min-height: 260px; margin-bottom: 20px;
    &.is-age {
      padding-bottom: 45px;
    }
  }
}
</style>
